Core.ContractsRouter = Core.SubRouter.extend({
    routes: {
        '': 'contracts',
        'new': 'newContract',
        ':id': 'viewContract',
    },

    contracts: function() {
        if (!Core.apiToken) location.hash = '';
        app.setMainView(new ContractListView(), 'directory');
    },

    newContract: function() {
        if (!Core.apiToken) location.hash = '';
        app.setMainView(new NewContractView(), 'directory');
    },

    viewContract: function(id) {
        app.setMainView(new ContractDetailView({id: id}), 'directory', { cssLoggedIn: true });
    }
});